jQuery(document).ready(function ($) {
    var rs = [];
    var rsIndex = 0;

    var rsConfig = {
        'nav': false,
        'prevnext': false
    };

    // glowny kod slidera
    $('.auto-slider').each(function () {
        var container = $(this);
        var autoSlide = true;
        var enableSlide = true;
        var lastSlideActive = container.hasClass('lastSlideActive')

        rsIndex += 1;
        rs[rsIndex] = {};

        var slider = rs[rsIndex];

        slider.container = container;
        slider.currentItem = 0;

        if (container.children('ul.slider').children('li').length > 1) {
            if (container.hasClass('prevnext')) {
                rsConfig.prevnext = true;
            }

            if (container.hasClass('nav')) {
                rsConfig.nav = true;
            }

            if (container.hasClass('auto-slide')) {
                autoSlide = true;
            }

            if (rsConfig.prevnext && slider.container.find('.prev').length < 1) {
                slider.container.append('<div class="prev"><span>&lsaquo;</span></div>');
                slider.container.append('<div class="next"><span>&rsaquo;</span></div>');
            }

            var slideChanged = false;
            var total = slider.container.children('ul').first().children('li').length;

            slider.container.find('.next').on('click', function () {
                goNext();
                slideChanged = true;
            });

            slider.container.on("swipeleft", function (event) { goNext(); });

            slider.container.find('.prev').on('click', function () {
                goBack();
                slideChanged = true;
            });

            slider.container.on("swiperight", function (event) { goBack(); });

            function goNext() {
                slider.currentItem += 1;

                if (slider.currentItem >= total) {
                    slider.currentItem = 0;
                    //return false;
                }

                if (rsConfig.nav) {
                    console.log(slider.currentItem)
                    slider.container.find('ul.nav').find('li').removeClass('active');
                    slider.container.find('ul.nav').find('li').eq(slider.currentItem).addClass('active');
                }
                slider.container.children('ul').first().children('li').css('transform', 'translateX(' + (- (slider.currentItem * 100) + '%') + ')');
            }

            function goBack() {
                slider.currentItem -= 1;

                if (slider.currentItem < 0) {
                    slider.currentItem = total - 1;
                    //  return false;
                }

                if (rsConfig.nav) {
                    slider.container.find('ul.nav').find('li').removeClass('active');
                    slider.container.find('ul.nav').find('li').eq(slider.currentItem).addClass('active');
                }
                slider.container.children('ul').first().children('li').css('transform', 'translateX(' + (- (slider.currentItem * 100) + '%') + ')');
            }

            slider.container.mouseenter(function () {
                enableSlide = false;
            });
            slider.container.mouseleave(function () {
                enableSlide = true;
            });
            var progress = 0;

            if (autoSlide === true) {
                console.log('autoslide');
                console.log('-----');
                setInterval(function () {
                    if (enableSlide) {
                        if (rsConfig.nav) {
                            slider.container.find('ul.nav').find('li.active').find('.progress span').css('width', (progress / 7) + '%');
                            progress += 10;
                        }
                        if (progress > 700) {
                            progress = 0;
                            if (rsConfig.nav) {
                                slider.container.find('ul.nav').find('span').css('width', '0');
                            }
                            goNext();
                        }
                    }

                    if (slideChanged) {
                        progress = 0;
                        slideChanged = false;
                        if (rsConfig.nav) {
                            slider.container.find('ul.nav').find('span').css('width', '0');
                        }
                    }
                }, 1500);
            }

            slider.container.children('ul').first().children('li').each(function () {
                //slider.container.find('ul.nav').append('<li></li>');
                slider.currentItem++;
            });
            slider.currentItem = 0;

            if (rsConfig.nav) {
                slider.container.find('ul.nav').find('li').first().addClass('active');

                slider.container.find('ul.nav').find('li').on('click', function () {
                    slideChanged = true;
                    var index = $(this).index();

                    slider.container.find('ul.nav').find('li').removeClass('active');
                    slider.container.find('ul.nav').find('li').eq(index).addClass('active');

                    slider.currentItem = index;
                    slider.container.children('ul').first().children('li').css('transform', 'translateX(' + (-(slider.currentItem * 100) + '%') + ')');
                });
            }

            if (lastSlideActive) {
                slideChanged = true;
                var index = container.children('ul.slider').children('li').length - 1

                if (rsConfig.nav) {
                    slider.container.find('ul.nav').find('li').removeClass('active');
                    slider.container.find('ul.nav').find('li').eq(index).addClass('active');
                }

                slider.currentItem = index;
                slider.container.children('ul').first().children('li').css('transform', 'translateX(' + (-(slider.currentItem * 100) + '%') + ')');
            }


            if (slider.container.closest('.tt-unregister-slider').length < 1) {

                $(window).on("resize load", function () {
                    // Set .right's width to the window width minus 480 pixels
                    var total = slider.container.children('ul').first().children('li').length;
                    var window_width = $(window).width();
                    if (window_width > 1024 && slider.container.hasClass('start-2') && total < 3) {
                        slider.container.find('.prev, .next').css('display', 'none');
                    }
                    else if (window_width <= 1024 && window_width > 900 && total < 4) {
                        slider.container.find('.prev, .next').css('display', 'none');
                    }
                    else if (window_width <= 900 && window_width > 650 && total < 3) {
                        slider.container.find('.prev, .next').css('display', 'none');
                    }
                    else if (window_width < 650 && total < 2) {
                        slider.container.find('.prev, .next').css('display', 'none');
                    }
                    else {
                        slider.container.find('.prev, .next').css('display', 'block');
                    }
                    // Invoke the resize event immediately

                    var max_height = 0;
                    var this_height = 0;

                    container.children('ul.slider').children('li').each(function () {
                        var this_height = $(this).find('.left').outerHeight();
                        if (this_height > max_height) {
                            max_height = this_height;
                        }
                    });

                    container.children('ul.slider').children('li').css('height', max_height);

                }).resize();
            }
        }
    });
});
